// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1t-2";
export var placeholderIcon = "_1t-3";
export var thumbnailCanvas = "_1t-1";
export var thumbnailWrapper = "_1t-0";